<template>
    <div class="container">
        <template v-for="(n, i) in 51" :key="i">
            <label v-if="isBitOne(i + seed)">
                {{ i }}
            </label>
        </template>
    </div>
</template>

<script>

import { useGameStore } from '@/stores/game';

export default{
    props: {
        seed: Number
    },
    setup(){
        const gameStore = useGameStore()
        return {
            gameStore
        }
    },
    methods:{
        isBitOne(number){
            const bit =  Math.pow(2, this.gameStore.currentPage)
            const boolean = (number & bit)
            return boolean
        }
    }
}
</script>

<style scoped>
label{
    width: 50px;
    background-color: cadetblue;
    border-radius: 55%;
    padding: 5px;
    color: white;
    display: inline-block;
    user-select: none;
    margin-right: 5px;
    margin-top: 5px;
}
.container{
    width: 75%;
    margin: auto;
}
</style>